<template>
  <div v-show="isHistoryShow" class="drawer-history" style="z-index:1002">
    <div v-if="searchHistory[searchType] && searchHistory[searchType].length > 0" class="drawer-history-body">
      <div
        v-for="(kw, k) in searchHistory[searchType]"
        :key="k"
        class="drawer-history-item"
        @click="setKeywords(kw)"
      >
        {{ kw }}
      </div>
      <div class="drawer-history-title" @click="clearHistory">清空历史记录</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    searchType: { type: String, default: '' },
    isHistoryShow: { type: Boolean, default: false },
  },
  data() {
    return {
      searchHistory: {},
    }
  },
  watch: {
    isHistoryShow(newValue, oldValue) {
      if (newValue) this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
    },
  },
  methods: {
    clearHistory() {
      this.searchHistory[this.searchType] = []
      localStorage.searchHistory = JSON.stringify(this.searchHistory)
    },
    setKeywords(keywords) {
      this.$emit('setKeywords', keywords)
    },
  },
}
</script>
